import type { PostHogInterface } from "posthog-js";
import {
    canNativeShare,
    shareOrCopy,
    type ShareOutcome,
} from "@wags/ui/share-or-copy.ts";

export type ShareSource = "dog-page" | "feed" | "after-save-prompt";

export function shareListingWithTracking({
    posthog,
    source,
    dogId,
    dogName,
    title,
    draft,
}: {
    posthog: Pick<PostHogInterface, "capture">;
    source: ShareSource;
    dogId: string;
    dogName?: string;
    title: string;
    draft?: boolean;
}): Promise<ShareOutcome> {
    posthog.capture("share_clicked", {
        source,
        dogId,
        dogName,
        platform: canNativeShare() ? "native" : "clipboard",
    });
    const url = new URL(
        draft ? `/dog/${dogId}/draft` : `/dog/${dogId}`,
        window.location.origin,
    ).toString();
    return shareOrCopy(title, url).then((outcome) => {
        posthog.capture("share_completed", {
            source,
            platform: outcome.method,
            success: outcome.status === "completed",
            cancelled: outcome.status === "cancelled",
            error: outcome.error,
            dogId,
        });
        return outcome;
    });
}
